import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { IGNORAR_ERRO_GLOBAL } from '@core/services/api/interceptor';
import { BaseCrud } from '@core/services/api/routes/helpers/baseCrud';
import { JornadaResposta, MissaoResposta } from '@core/jornada/jornada.model';
import { ApiEndpointService } from '../../api-endpoint.service';

/**
 * `/jornada` — Órbita Financeira (financeiro-api `JornadaController`).
 * Leitura gateada por `Dashboard_Summary`; a exceção "não se aplica" exige a
 * permissão `_Update` do domínio da missão (a API responde 403 quando falta).
 *
 * `@Injectable`, como `NotificationRoute`: quem consome (o `JornadaService`,
 * construído pela barra superior) não pertence a módulo lazy de feature.
 */
@Injectable({ providedIn: 'root' })
export class JornadaRoute extends BaseCrud {
  constructor() {
    super(inject(ApiEndpointService));
  }

  getUrl(): string {
    return `${this.api.getApiUrl()}/jornada`;
  }

  /**
   * Com `IGNORAR_ERRO_GLOBAL`: a chamada nasce com a barra superior, em toda
   * tela do tenant, e um 500 dela não pode virar toast global numa tela que
   * não pediu nada — quem avisa é o overlay da jornada. As escritas abaixo
   * NÃO levam a marca: são ação do usuário, e o aviso delas é do serviço.
   */
  carregar(): Observable<JornadaResposta> {
    return this.api.getHttp().get<JornadaResposta>(this.getUrl(), { context: new HttpContext().set(IGNORAR_ERRO_GLOBAL, true) });
  }

  naoSeAplica(id: string, justificativa: string): Observable<MissaoResposta> {
    return this.api.getHttp().post<MissaoResposta>(`${this.getUrl()}/missoes/${id}/nao-se-aplica`, { justificativa });
  }

  removerExcecao(id: string): Observable<void> {
    return this.api.getHttp().delete<void>(`${this.getUrl()}/missoes/${id}/nao-se-aplica`);
  }
}
